// deactivate services

import _ from 'lodash';
import * as storage from './storage';
import { checkCurrentDateIsBefore } from './checkTripStarts';

export function deactivateServices() {
    if (storage.get('bookingData') !== null) {
        if (storage.get('bookingData') != null && storage.get('bookingData').data != null) {
            let day = new Date();
            day.setHours(23, 59, 59, 999);

            // Prüfung auf Rückreisedatum: wenn Vergangenheit → Service deaktivieren
            let retDate = storage.get('bookingData').data.searchParams.retDate;

            let retDateD = retDate.substr(0, 2);
            let retDateM = retDate.substr(3, 2);
            let retDateY = retDate.substr(6, 4);

            let compareDateRet = new Date(retDateY + '-' + retDateM + '-' + retDateD);
            compareDateRet.setHours(23, 59, 59, 999);

            if (compareDateRet.getTime() < new Date(day).getTime()) {
                let retS = ['EmergencyContact'];
                _.forEach(retS, function (v) {
                    window.deactivateServices.push(v);
                });
            }

            // Prüfung auf Rückreisedatum: Wenn heute Abreisetag → Kachel nicht mehr anzeigen
            if (checkCurrentDateIsBefore(retDate)) {
                let retS = ['ExtraServices'];
                _.forEach(retS, function (v) {
                    window.deactivateServices.push(v);
                });
            }

            if (process.env.VITE_DEACTIVATE_SERVICES !== undefined) {
                let deactivateServices = JSON.parse(process.env.VITE_DEACTIVATE_SERVICES);

                _.forEach(deactivateServices, function (v) {
                    window.deactivateServices.push(v);
                });
            }
        }
    }
}
